<template>
    <SeguimientoDocumentos></SeguimientoDocumentos>
</template>
<script>
import SeguimientoDocumentos from '../components/SeguimientoDocumentos.vue';
export default {
    name: 'SentDocumentsView',
    components: {
        SeguimientoDocumentos,
    }
}
</script>